import {
  faPhone,
  faLocation,
  faMailBulk,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useRef } from "react";

import {} from "@fortawesome/free-brands-svg-icons";
import { useForm } from "react-hook-form";
import emailjs from "emailjs-com";
import { toast } from "react-toastify";

const ContactForm = () => {
  const form = useRef();
  const { register, handleSubmit } = useForm();
  const onSubmit = (data) => {
    console.log(data, form.current);

    emailjs
      .sendForm(
        "service_1geoxmn",
        "template_q9tlw3q",
        form.current,
        "DHTwPKfJ_pLfioTSS"
      )
      .then(
        (result) => {
          console.log(result.text);
          toast.success(
            "I recieve your message as soon as possible i will reply you!"
          );
        },
        (error) => {
          console.log(error.text);
          toast.error("Something error");
        }
      );
  };
  return (
    <div
      id="contact"
      className="hero bg-gradient-to-r from-slate-200 to-red-200 pt-10"
    >
      <div className="hero-content w-full flex lg:justify-around flex-col lg:flex-row">
        <div className="text-center lg:text-left">
          <p>
            <FontAwesomeIcon icon={faPhone} />
            <span className="px-4">+351920165694</span>
          </p>
          <p>
            <FontAwesomeIcon icon={faLocation} />
            <span className="px-4">Rua do passdico 98, Lisbon, Portugal</span>
          </p>
          <p>
            <FontAwesomeIcon icon={faMailBulk} />
            <span className="px-4">alnoman.cs@gmail.com</span>
          </p>
        </div>
        <div>
          <h1 className="text-2xl font-bold">How can i help you!</h1>

          <div className="card flex-shrink-0 w-96 max-w-sm shadow-2xl ">
            <div className="card-body">
              <form ref={form} onSubmit={handleSubmit(onSubmit)}>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Name</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered"
                    placeholder="First name"
                    {...register("firstName", {
                      required: true,
                      maxLength: 80,
                    })}
                  />
                </div>

                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Email</span>
                  </label>
                  <input
                    className="input input-bordered"
                    type="text"
                    placeholder="Email"
                    {...register("email", {
                      required: true,
                      pattern: /^\S+@\S+$/i,
                    })}
                  />
                </div>

                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Message</span>
                  </label>
                  <input
                    type="text"
                    className="input input-bordered"
                    placeholder="Your Message"
                    {...register("message", {
                      required: true,
                      maxLength: 80,
                    })}
                  />
                </div>

                <div className="form-control mt-6">
                  <input className="btn" type="submit" />
                </div>
              </form>
              {/* <form onClick={handleEmail}>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Name</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name"
                    name="name"
                    required
                    className="input input-bordered"
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Email</span>
                  </label>
                  <input
                    type="email"
                    placeholder="email"
                    name="email"
                    required
                    className="input input-bordered"
                  />
                </div>
                <div className="form-control">
                  <label className="label">
                    <span className="label-text">Message</span>
                  </label>
                  <textarea
                    rows="50"
                    name="message"
                    placeholder="Message"
                    required
                    className="input input-bordered"
                  />
                </div>
                <div className="form-control mt-6">
                  <button className="btn btn-primary">Send Message</button>
                </div>
              </form> */}
            </div>
          </div>
        </div>
      </div>
    </div>

    // <div className="ContactForm">
    //   <div className="container">
    //     <div className="row">
    //       <div className="col-12 text-center">
    //         <div className="contactForm">
    //           <form id="contact-form" noValidate>
    //             {/* Row 1 of form */}
    //             <div className="row formRow">
    //               <div className="col-6">
    //                 <input
    //                   type="text"
    //                   name="name"
    //                   className="form-control formInput"
    //                   placeholder="Name"
    //                 ></input>
    //               </div>
    //               <div className="col-6">
    //                 <input
    //                   type="email"
    //                   name="email"
    //                   className="form-control formInput"
    //                   placeholder="Email address"
    //                 ></input>
    //               </div>
    //             </div>
    //             {/* Row 2 of form */}
    //             <div className="row formRow">
    //               <div className="col">
    //                 <input
    //                   type="text"
    //                   name="subject"
    //                   className="form-control formInput"
    //                   placeholder="Subject"
    //                 ></input>
    //               </div>
    //             </div>
    //             {/* Row 3 of form */}
    //             <div className="row formRow">
    //               <div className="col">
    //                 <textarea
    //                   rows={3}
    //                   name="message"
    //                   className="form-control formInput"
    //                   placeholder="Message"
    //                 ></textarea>
    //               </div>
    //             </div>
    //             <button className="submit-btn" type="submit">
    //               Submit
    //             </button>
    //           </form>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </div>
  );
};

export default ContactForm;
